import styled from 'styled-components';

export const PaymentSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
`;

export const PaymentTitle = styled.div`
    display: flex;
    justify-content: space-between;

    p {
        color: #71717a;
        cursor: pointer;
    }

    p:hover {
        text-decoration: underline;
    }
`;

export const PaymentContainer = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;

    gap: 0.75rem;
    outline: 2px solid var(--Silver-100, #ededed);
    border: none;
    border-radius: 1.25rem;
    padding: 0.75rem;

    .row {
        display: flex;
        gap: 0.75rem;
    }
`;

export const CardBox = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.75rem;
    align-items: center;
    align-self: stretch;
    border-radius: 0.75rem;
    border: 1.5px solid var(--Supernova-500, #ffcf00);

    .card-brand {
        width: 4.5rem;
        height: 3rem;
        border-radius: 0.375rem;
        border: 1px solid var(--Silver-200, #dfdfdf);
        background: #fff;

        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0.5rem;

        svg {
            width: 100%;
        }
    }

    .sub-session {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 1.5rem;
    }

    .card-pile {
        width: 100%;
        text-align: right;
    }

    .refresh-icon {
        width: 1.5rem;
        height: 1.5rem;
        cursor: pointer;
        color: #71717a;
    }

    p.last-digits {
        color: #71717a;
    }
`;

export const InstallmentsBox = styled.div`
    display: flex;
    padding: 0.75rem;
    align-items: center;
    justify-content: flex-end;
    gap: 1.5rem;
    align-self: stretch;
    border-radius: 0.75rem;
    border: 1.5px solid var(--Neutral-200, #e4e4e7);

    .installments-icon {
        width: 1.5rem;
        height: 1.5rem;
        cursor: pointer;
        color: #71717a;
    }
`;
